import React from 'react';
import { Typography } from '@mui/material';
import CustomizedDialogs from '../../../components/Modal';
import { RevShareEntry } from '../../../models/RevShareData';
import { getEntryStatus } from '../../../data/rev-share/helpers/revShareEntryUtils';
import { Bold } from '../../../components/Bold';

interface RemoveEntryModalProps {
  onClose: () => void;
  entry: RevShareEntry | null;
  onConfirm: (entry: RevShareEntry) => void;
}

const RemoveEntryModal: React.FC<RemoveEntryModalProps> = ({ onClose, entry, onConfirm }) => {
  const status = entry ? getEntryStatus(entry, new Date()).toLowerCase() : '';

  return (
    <CustomizedDialogs
      open={entry !== null}
      className='rev-share-confirmation'
      title='Remove record?'
      primaryButtonText='Yes, remove'
      secondaryButtonText='No, keep'
      handleSave={() => entry && onConfirm(entry)}
      handleCancel={onClose}
      onClose={onClose}>
      <Typography variant='p16' color='secondary.main'>
        Are you sure you want to remove this <Bold>{status}</Bold> fee share entry?
      </Typography>
      <Typography variant='p16' color='secondary.main' mt={3}>
        This action cannot be undone.
      </Typography>
    </CustomizedDialogs>
  );
};

export default RemoveEntryModal;
